import { render, staticRenderFns } from "./PictureEven.vue?vue&type=template&id=618c8796&scoped=true&"
import script from "./PictureEven.vue?vue&type=script&lang=js&"
export * from "./PictureEven.vue?vue&type=script&lang=js&"
import style0 from "./PictureEven.vue?vue&type=style&index=0&id=618c8796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618c8796",
  null
  
)

export default component.exports